exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules=false!./~/postcss-loader/lib!./~/sass-loader!./styles/_variables.scss
// module id = BzJZ
// module chunks = 1